import styled from 'styled-components';
import { Button } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import React from 'react';

const ErrorImage = styled.img`
  width: 100%;
  max-width: 150px;
`;

const Title = styled.div`
  color: #505050;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
`;

const SubTitle = styled.div`
  color: #505050;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  margin-bottom: 8px;
`;

const Text = styled.div`
  color: #707070;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  max-width: 270px;
  width: 100%;
  margin-bottom: 40px;
`;

const Layout = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;

const MuiButton = styled(Button)`
  width: 144px;
  padding: 12px 24px;
`;

const Error = ({ handleCloseError }) => {
  const { t } = useTranslation();
  return (
    <>
      <Layout>
        <ErrorImage src="errorconection.svg" alt="error" id="transactions-see-detail-error" />
        <Title>{t('transactions.modalDetail.errorTitle')}</Title>
        <SubTitle>{t('transactions.modalDetail.errorSubTitle')}</SubTitle>
        <Text>{t('transactions.modalDetail.errorDetail')}</Text>
        <MuiButton onClick={handleCloseError} id="transactions-see-detail-failure-close">
          {t('transactions.modalDetail.errorButton')}
        </MuiButton>
      </Layout>
    </>
  );
};

export default Error;
